import CaseStudiesPage, { getServerSideProps } from './case-studies';
export default CaseStudiesPage;
export { getServerSideProps };
